import { Box, Button, Fade, IconButton, Modal, Typography, useTheme, Link } from '@mui/material';
import Markdown from 'react-markdown';
import CloseIcon from '@mui/icons-material/Close';
import { display } from '../../redux/reducers/sidebar';

const SimpleModal = ({ open, setOpen, title, body, aiModalLoading }) => {
  const theme = useTheme();
  const style = {
    position: 'absolute',
    right: '10%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    display: 'flex',
    flexDirection: 'column',

    padding: '0px',
    height: '85%',
    width: { xs: '90%', sm: '60%' },
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50% )',
    fontFamily: theme.typography.fontFamily,
  };
  const fontSize = '14px';
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={() => setOpen(false)}
    >
      <Fade in={open}>
        <Box className="custom-scrollbar" sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              paddingTop: 1,
              display: 'flex',
              fontWeight: 'bold',
              flexDirection: 'row',
              color: 'white',

              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ marginLeft: '10px', marginTop: '5px' }}>{title}</Box>
            <Box sx={{ marginTop: '-2px' }}>
              <IconButton aria-label="delete" onClick={() => setOpen(false)}>
                <CloseIcon sx={{ color: 'white' }} />
              </IconButton>
            </Box>
          </Box>
          {aiModalLoading ? (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              AI Analysing your data, please wait....
            </Box>
          ) : (
            <Box
              sx={{
                overflow: 'scroll',
                padding: '0px 30px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  fontFamily: theme.typography.fontFamily,
                  '& ol, & ul': { pl: 3, m: 0 },
                  '& p, & li, & a, & h1, & h2, & h3, & h4, & h5, & h6': { fontFamily: 'inherit' },
                }}
              >
                <Markdown
                  components={{
                    p: (props) => (
                      <Typography variant="body1" component="p" sx={{ fontFamily: 'inherit', fontSize: fontSize }} {...props} />
                    ),
                    li: (props) => (
                      <li>
                        <Typography variant="body1" component="span" sx={{ fontFamily: 'inherit', fontSize: fontSize }} {...props} />
                      </li>
                    ),
                    a: (props) => (
                      <Link
                        target="_blank"
                        rel="noopener"
                        underline="hover"
                        sx={{ fontFamily: 'inherit', color: 'blue', fontSize: fontSize }}
                        {...props}
                      />
                    ),
                    strong: (props) => <Typography component="strong" sx={{ fontFamily: 'inherit', fontWeight: 'bold' }} {...props} />,
                  }}
                >
                  {body}
                </Markdown>
              </Box>
            </Box>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default SimpleModal;
